import { render, staticRenderFns } from "./edit-main.vue?vue&type=template&id=9dad96bc&scoped=true&"
import script from "./edit-main.vue?vue&type=script&lang=js&"
export * from "./edit-main.vue?vue&type=script&lang=js&"
import style0 from "./edit-main.vue?vue&type=style&index=0&id=9dad96bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dad96bc",
  null
  
)

export default component.exports